import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";
import Link from "@mui/material/Link";

import { colors } from "@dotnet/telematics-design-system";

import { TooltipGeneral } from "components/DesignComponents/Tooltips/TooltipGeneral";

import { IconLinkProps } from "../types";

const IconLink = ({ link, tooltip, icon }: IconLinkProps) => {
    const { blue700, gray700 } = colors;

    const { t } = useTranslation();

    return (
        <TooltipGeneral disableTouchListener title={t(`Auth##${tooltip}`)}>
            <Link
                target="_blank"
                rel="noreferrer"
                href={link}
                underline="hover"
                css={css({
                    display: "inline-flex",
                    color: gray700,

                    "&:hover": {
                        color: blue700
                    }
                })}
            >
                {icon}
            </Link>
        </TooltipGeneral>
    );
};

export default IconLink;
